import color from "../../../../../theme/color";
import { IconForm } from "../../../Icon/index.styled";

interface LnbIconRenderProps {
  icon: any;
  iconColor?: string;
  iconSize?: number;
}

/**
 * 아이콘 렌더
 * @param icon
 * @returns
 */
export const lnbIconRender = ({
  icon,
  iconColor,
  iconSize = 20,
}: LnbIconRenderProps) => {
  return (
    <IconForm
      component={icon}
      color={iconColor || color.gray4}
      style={{
        fontSize: iconSize,
        ...(iconSize < 20 && { padding: (20 - iconSize) / 2 }),
      }}
    />
  );
};
